
















import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import SummaryResultApis from '@/mixins/requests/branch/SummaryResultApis.vue'
import RadarChartSubject, { RadarChartRecords } from '@/components/common/molecules/RadarChartSubject.vue'
import ScoreSummaryTable from '@/components/common/molecules/ScoreSummaryTable.vue'
import { GeneralSummaryData, GeneralSummary } from '@/models/api/common/SummaryResultTypes.vue'
import Color from '@/mixins/constant/Color.ts'

@Component({
  components: {
    RadarChartSubject,
    ScoreSummaryTable,
  },
})
export default class WholeData extends Mixins(SummaryResultApis) {
  @Prop()
  studyContentId!: string
  @Prop()
  store!: { summaryData: GeneralSummaryData }
  @Prop({ default: false })
  isStudyModeRecommend!: boolean

  private labelColors = [
    Color.SUBJECT_KO, // 国語
    Color.SUBJECT_SU, // 数学
    Color.SUBJECT_EI, // 英語
    Color.SUBJECT_RI, // 理科
    Color.SUBJECT_SY, // 社会
  ]

  private activeTab = 1
  private tableLabels = [
    { key: 'academy', name: this.scoreLabelPush('塾内平均') },
    { key: 'branch', name: this.scoreLabelPush('教室内平均') },
    { key: 'total', name: this.scoreLabelPush('全国平均') },
  ]

  @Watch('summaryData')
  private onChangeSummaryData() {
    if (this.summaryData) {
      this.store.summaryData = this.summaryData
    }
  }

  private scoreLabelPush(labelName: string): string {
    return this.isStudyModeRecommend ? labelName + 'スコア' : labelName + '点'
  }

  private get chartRecords(): RadarChartRecords {
    return {
      labels: this.subjectLabels,
      total: {
        label: this.scoreLabelPush('全国平均'),
        data: this.totalChartData,
      },
      local: {
        label: this.scoreLabelPush('教室内平均'),
        data: this.branchChartData,
      },
    }
  }

  private get subjectLabels(): string[] {
    if (!this.summaryData) return []
    return this.summaryData.total.summary
      .filter((summary: GeneralSummary) => {
        return summary.subjectCode
      })
      .map((summary) => {
        return summary.subjectName || ''
      })
  }

  private get totalChartData(): number[] {
    if (!this.summaryData) return []
    return this.summaryData.total.summary
      .filter((summary: GeneralSummary) => {
        return summary.subjectCode
      })
      .map((summary) => {
        if (this.isStudyModeRecommend) return summary.adjustAverage === null ? 0 : summary.adjustAverage
        else return summary.average === null ? 0 : summary.average
      })
  }

  private get branchChartData(): number[] {
    if (!this.summaryData || !this.summaryData.branch) return []
    return this.summaryData.branch.summary
      .filter((summary: GeneralSummary) => {
        return summary.subjectCode
      })
      .map((summary) => {
        if (this.isStudyModeRecommend) return summary.adjustAverage === null ? 0 : summary.adjustAverage
        else return summary.average === null ? 0 : summary.average
      })
  }

  private summaryData: GeneralSummaryData | null = null

  private async mounted() {
    if (this.store.summaryData) {
      this.summaryData = this.store.summaryData
    } else {
      Vue.prototype.$loading.start()
      try {
        this.summaryData = await this.getSummary(this.studyContentId)
      } catch (e) {
        if (e.response.data.status === 404) {
          // リクエストのテストIDが存在しない場合は404
          alert('集計情報が存在しません')
        } else if (e.response.data.status === 400) {
          // リクエスト不正
          alert('リクエストが不正です')
        }
      } finally {
        Vue.prototype.$loading.complete()
      }
    }
  }
}
